import React, { useEffect, useState } from 'react'
import Spining from '../UI/Spining/Spining'
import ReactDatePicker from "react-datepicker";
import AdvanceDataTable from '../UI/Table/AdvanceDataTable';
import AdminLayout from '../UI/Layout/AdminLayout';
import Title from '../UI/Text/Title';
import Axios from '../../axios/Axios';
import Select from "react-select";
import { HOST_URL, NODE_HOST_URL } from '../Dashboard/api/Api';
import { userloginDetails } from '../Utils/AdminAuth';
import { CONVERSATION_REPORT_DATA, EMPLOYEE_CAMPAIGN_DATA } from '../UI/Table/ColumnConst';

const ConversationReport = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;
    const username = lStorage.user.username;

    const [isLoading, setIsLoading] = useState(false);
    const [fromdate, setFromdate] = useState(new Date());
    const [todate, setTodate] = useState(new Date());
    const [channel, setChannel] = useState('whatsapp')
    const [allUsers, setAllUsers] = useState('')
    const [selecteduser, setSelectedusers] = useState("");
    const [campaignData, setCampaignData] = useState([]);
    const [totalCost, setTotalCost] = useState(null)
    const [conversationReport, setConversationReport] = useState([]);

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    useEffect(() => {
        allUserList();
        CampaignReports();
    }, []);

    const userHandler = (e) => {
        setSelectedusers(e.value);
    };

    const currentDate = (currentDate) => {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const allUserList = async () => {
        const parentParams = {
            user_id: userId,
            method: "retrieve",
            type: adminType,
            token: userToken
        }
        try {
            let { data } = await Axios.post(`${HOST_URL}/employee_user_list.php`, parentParams)
            if (data.success) {
                let filterData = data.data.map((x) => {
                    return ({ label: x.username, value: x.username })
                })
                // console.log(filterData)
                setAllUsers(filterData)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const CampaignReports = async () => {
        setIsLoading(true)
        let paramData = {
            user_id: userId,
            token: userToken,
            username: username,
            method: "conv_report",
            fromdate: currentDate(fromdate),
            todate: currentDate(todate)
        }
        try {
            let { data } = await Axios.post(`${NODE_HOST_URL}/conv_report`, paramData)
            if (data.success) {
                let totalCost = 0
                data.result.forEach((item) => {
                    let intValue = parseFloat(item.total_conv_cost);
                    totalCost += intValue;
                });
                if (selecteduser) {
                    let filterData = data.result.filter(x => x.username == selecteduser)
                    setConversationReport(filterData)
                }
                else {
                    setConversationReport(data.result)
                }
                setTotalCost(totalCost)
            }
        } catch (error) {
            console.log(error)
        }
        setIsLoading(false)
    }

    const fromdateHandler = (data) => {
        setFromdate(data);
    };

    const todateHandler = (data) => {
        setTodate(data);
    };

    return (
        <div>
            <AdminLayout>
                {/* <Title isButton={false}> Conversation Report </Title> */}

                <div className="row">
                    <div className="">
                        <div className="card">
                            {/* {alert.status === true ? (
                                <div className={alert.bgColor} role="alert">
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                    <div className="">{alert.errorMessage}</div>
                                </div>
                            ) : null} */}

                            {isLoading && <Spining />}

                            <div className="card-body">
                                <div className="filter-option" >
                                    <div className='row mb-2'>
                                        <div className='col-6'>
                                            <h6 className="card-subtitle text-muted">
                                                <b>Conversation Report{" "}</b>
                                            </h6>
                                        </div>
                                        <div className='col-6'>
                                            <button type="button" className="btn btn-info float-right" onClick={CampaignReports}>Search</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label>Select User</label>
                                            <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                                <div className="input-group mb-2 mr-sm-2 ">
                                                    {/* <div className="input-group-text">User </div> */}
                                                    <Select
                                                        onChange={userHandler}
                                                        options={allUsers}
                                                        isSearchable={true}
                                                        placeholder="All Users"
                                                        styles={customStyles}
                                                        isClearable={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <label>From Date</label>
                                            <div className="input-group mb-2 mr-sm-2 table2">
                                                {/* <div className="input-group-text">
                          <FontAwesomeIcon icon={faCalendarAlt} />
                        </div> */}

                                                <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    value={fromdate}
                                                    onChange={fromdateHandler}
                                                    selected={fromdate}
                                                    placeholderText="From Date"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label>To Date</label>
                                            <div className="input-group mb-2 mr-sm-2 table3">
                                                {/* <div className="input-group-text">
                          <FontAwesomeIcon icon={faCalendarAlt} />
                        </div> */}
                                                <ReactDatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="dd/MM/yyyy"
                                                    value={todate}
                                                    onChange={todateHandler}
                                                    selected={todate}
                                                    placeholderText="Date To"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <AdvanceDataTable
                                        tableName={""}
                                        tableCell={CONVERSATION_REPORT_DATA}
                                        tableData={conversationReport}
                                        isLoading={isLoading}
                                        // isError={alert.errorMessage}
                                        filterstatus={false}
                                        pagination={true}
                                    />
                                    <div className="d-flex justify-content-end mr-2">
                                        <small className="mb-2">
                                            {/* Total cost: {parseFloat(totalCost).toFixed(2)} */}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminLayout>
        </div>
    )
}

export default ConversationReport
